(function() {
    class CaseStudiesSlider {
        constructor(){
            this.slider = document.getElementById('caseStudiesSlider');
            this.slides = document.querySelectorAll('.case-study-slide');
            this.prevBtn = document.getElementById('prevCaseStudy');
            this.nextBtn = document.getElementById('nextCaseStudy');
            this.dots = document.querySelectorAll('.case-study-dot');
            this.currentIndex = 0;
            this.totalSlides = this.slides.length;
            this.autoPlayInterval = null;
            this.autoPlayDelay = 5000; // 5 seconds
            this.init();
        }
        init() {
            if (!this.slider || this.slides.length === 0) return;
            // Set initial positions for all slides
            this.slides.forEach((slide, index)=>{
                slide.style.position = 'absolute';
                slide.style.width = '100%';
                slide.style.top = '0';
                slide.style.left = `${100 * index}%`;
                slide.style.display = 'block';
                slide.style.transition = 'left 0.5s ease-in-out';
            });
            this.setupEventListeners();
            this.updateSlider();
            this.startAutoPlay();
        }
        setupEventListeners() {
            // Navigation buttons
            if (this.prevBtn) this.prevBtn.addEventListener('click', ()=>this.prevSlide());
            if (this.nextBtn) this.nextBtn.addEventListener('click', ()=>this.nextSlide());
            // Dot indicators
            this.dots.forEach((dot, index)=>{
                dot.addEventListener('click', ()=>this.goToSlide(index));
            });
            // Enhanced Touch/swipe support with improved mobile handling
            let startX = 0;
            let startY = 0;
            let endX = 0;
            let endY = 0;
            let isDragging = false;
            let startTime = 0;
            let isHorizontalSwipe = false;
            const handleTouchStart = (e)=>{
                startX = e.touches[0].clientX;
                startY = e.touches[0].clientY;
                endX = startX;
                endY = startY;
                isDragging = true;
                startTime = Date.now();
                isHorizontalSwipe = false;
                this.stopAutoPlay(); // Stop autoplay during touch
                // Add visual feedback for touch
                this.slider.style.cursor = 'grabbing';
                this.slider.style.transition = 'none';
            // Don't prevent default here - let vertical scrolling work initially
            // We'll prevent it only when we detect horizontal swipes
            };
            const handleTouchMove = (e)=>{
                if (!isDragging) return;
                endX = e.touches[0].clientX;
                endY = e.touches[0].clientY;
                const deltaX = Math.abs(endX - startX);
                const deltaY = Math.abs(endY - startY);
                // Determine if this is a horizontal swipe
                // Only prevent default if horizontal movement is significantly greater
                if (deltaX > deltaY * 1.5 && deltaX > 15) {
                    isHorizontalSwipe = true;
                    // Prevent vertical scrolling during clear horizontal swipe
                    e.preventDefault();
                }
            // If vertical movement is greater, allow default scrolling behavior
            };
            const handleTouchEnd = (e)=>{
                if (!isDragging) return;
                isDragging = false;
                // Reset visual feedback
                this.slider.style.cursor = '';
                this.slider.style.transition = '';
                if (isHorizontalSwipe) this.handleSwipe(startX, endX, startTime);
                this.startAutoPlay(); // Resume autoplay after touch
            };
            // Add touch event listeners with improved options
            this.slider.addEventListener('touchstart', handleTouchStart, {
                passive: false,
                capture: true
            });
            this.slider.addEventListener('touchmove', handleTouchMove, {
                passive: false,
                capture: true
            });
            this.slider.addEventListener('touchend', handleTouchEnd, {
                passive: true
            });
            // Prevent context menu on long press
            this.slider.addEventListener('contextmenu', (e)=>{
                e.preventDefault();
            });
            // Pause autoplay on hover
            this.slider.addEventListener('mouseenter', ()=>this.stopAutoPlay());
            this.slider.addEventListener('mouseleave', ()=>this.startAutoPlay());
            // Enhanced keyboard navigation with mobile support
            document.addEventListener('keydown', (e)=>{
                // Only handle keyboard navigation if not typing in an input
                if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;
                if (e.key === 'ArrowLeft') {
                    e.preventDefault();
                    this.prevSlide();
                }
                if (e.key === 'ArrowRight') {
                    e.preventDefault();
                    this.nextSlide();
                }
            });
        }
        handleSwipe(startX, endX, startTime) {
            const diff = startX - endX;
            const deltaX = Math.abs(diff);
            const deltaTime = Date.now() - startTime;
            // Lower threshold for mobile (20px instead of 30px)
            const threshold = 20;
            // Velocity-based detection for faster swipes
            const velocity = deltaX / deltaTime;
            const velocityThreshold = 0.3; // pixels per ms
            if (deltaX > threshold || velocity > velocityThreshold) {
                if (diff > 0) // Swipe left - next slide
                this.nextSlide();
                else // Swipe right - previous slide
                this.prevSlide();
            }
        }
        updateSlider() {
            // Update slide positions using left positioning
            this.slides.forEach((slide, index)=>{
                const leftPosition = 100 * (index - this.currentIndex);
                slide.style.left = `${leftPosition}%`;
            });
            // Update dot indicators
            this.dots.forEach((dot, index)=>{
                dot.classList.toggle('bg-blue-600', index === this.currentIndex);
                dot.classList.toggle('bg-slate-300', index !== this.currentIndex);
            });
            // Update navigation buttons
            if (this.prevBtn) this.prevBtn.style.opacity = this.currentIndex === 0 ? '0.5' : '1';
            if (this.nextBtn) this.nextBtn.style.opacity = this.currentIndex === this.totalSlides - 1 ? '0.5' : '1';
        }
        nextSlide() {
            if (this.currentIndex < this.totalSlides - 1) {
                this.currentIndex++;
                this.updateSlider();
            }
        }
        prevSlide() {
            if (this.currentIndex > 0) {
                this.currentIndex--;
                this.updateSlider();
            }
        }
        goToSlide(index) {
            if (index >= 0 && index < this.totalSlides) {
                this.currentIndex = index;
                this.updateSlider();
            }
        }
        startAutoPlay() {
            this.stopAutoPlay();
            this.autoPlayInterval = setInterval(()=>{
                if (this.currentIndex < this.totalSlides - 1) this.nextSlide();
                else this.goToSlide(0); // Loop back to first slide
            }, this.autoPlayDelay);
        }
        stopAutoPlay() {
            if (this.autoPlayInterval) {
                clearInterval(this.autoPlayInterval);
                this.autoPlayInterval = null;
            }
        }
    }
    // Initialize slider when DOM is loaded
    document.addEventListener('DOMContentLoaded', ()=>{
        new CaseStudiesSlider();
    });
})();

//# sourceMappingURL=repo.506322fd.js.map
